import { TierLevel } from '../interfaces';

export const defaultTiers: TierLevel[] = [
  { tierName: 'cardPool', color: 'grey', cards: [] },
  { tierName: 'S', color: '#EB9694', cards: [] },
  { tierName: 'A', color: '#FEF3BD', cards: [] },
  { tierName: 'B', color: '#C1E1C5', cards: [] },
  { tierName: 'C', color: '#C4DEF6', cards: [] },
  { tierName: 'D', color: '#D4C4FB', cards: [] }
];
